import {
  createContext,
  useCallback,
  useContext,
  type FunctionComponent,
  type ReactNode,
} from 'react';

type onError = (message: string, metadata?: any) => void;

type LogContext = {
  onError?: onError;
};

const LogContext = createContext<LogContext>({ onError: undefined });

interface LogProviderProps {
  onError?: onError;
  children: ReactNode;
}

export const LogProvider: FunctionComponent<LogProviderProps> = ({
  children,
  onError,
}) => {
  const onErrorCallback = useCallback(
    (message: string, metadata: any) => onError?.(message, metadata),
    [onError],
  );

  return (
    <LogContext.Provider value={{ onError: onErrorCallback }}>
      {children}
    </LogContext.Provider>
  );
};

export const useLog = () => {
  const logContext = useContext<LogContext>(LogContext);

  return logContext;
};
